<template>
  <div class="headerDiv">
    <el-menu
      :default-active="$route.path"
      mode="horizontal"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      router
      @select="select"
      class="scrollable-menu"
      style="white-space: nowrap; display: flex; justify-content: flex-start; align-items: center;"
    >


      <div style="white-space: nowrap; display: flex; flex-wrap: nowrap;">
        <div v-for="menu in menus" :key="menu.id" class="el-menu-item"
             style="background: transparent; padding: 0; flex-shrink: 0;">

          <el-submenu v-if="menu.childrenList && menu.childrenList.length > 0" :index="menu.route" :id="renderId(menu)">
            <template slot="title">{{ menu.name }}</template>
            <div v-for="menuChild in menu.childrenList">
              <el-submenu v-if="menuChild.childrenList && menuChild.childrenList.length > 0" :index="menuChild.route"
                          :id="renderId(menuChild)">
                <template slot="title">{{ menuChild.name }}</template>
                <el-menu-item v-for="menuChild_child in menuChild.childrenList" :index="menuChild_child.route"
                              :key="menuChild_child.id">
                  {{ menuChild_child.name }}
                </el-menu-item>
              </el-submenu>

              <el-menu-item v-else :id="renderId(menuChild)" :index="menuChild.route">
                {{ menuChild.name }}
              </el-menu-item>
            </div>
          </el-submenu>

          <el-menu-item v-else :id="renderId(menu)" :index="menu.route">
            {{ menu.name }}
          </el-menu-item>
        </div>
      </div>

      <div
        style="display: flex; margin-left: auto; background: transparent; padding: 0; flex-shrink: 0; white-space: nowrap;">
        <el-submenu index="/">
          <template slot="title">{{ username }}<i class="el-icon-user-solid"></i></template>
          <el-menu-item index="" @click="change()">修改密码</el-menu-item>
          <el-menu-item index="/login">退出登录</el-menu-item>
        </el-submenu>

        <el-submenu index="/container">
          <template slot="title">帮助</template>
          <el-menu-item index="/container/help">注意事项</el-menu-item>
          <el-menu-item index="/container/noun">名词解释</el-menu-item>
        </el-submenu>
      </div>

    </el-menu>

    <!--修改密码-->
    <el-dialog
      title="修改密码"
      :visible="changeView"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="25%">
      <el-form label-position="left" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="80px"
               class="demo-ruleForm">
        <el-form-item label="用户名" prop="userName">
          <el-input style="width:200px;" v-model="ruleForm.userName" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="原密码" prop="prepassword">
          <el-input style="width:200px;" type="password" v-model="ruleForm.prepassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input style="width:200px;" type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="dstPassword">
          <el-input style="width:200px;" type="password" v-model="ruleForm.dstPassword" autocomplete="off"></el-input>
        </el-form-item>
        <div style="text-align: center">
          <el-button type="primary" @click="savePassword()">确定</el-button>
          <el-button @click="changeView=false">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';

export default {
  name: "vheader",
  computed: {
    ...mapState(['menus'])
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.dstPassword !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      driver: null,
      changeView: false,
      username: "",
      ruleForm: {
        userName: '',
        prepassword: '',
        password: '',
        dstPassword: '',
      },
      rules: {
        prepassword: [
          {required: true, message: '请输入原密码', trigger: 'blur'}
        ],
        password: [
          {required: true, validator: validatePass, trigger: 'blur'}
        ],
        dstPassword: [
          {required: true, validator: validatePass2, trigger: 'blur'}
        ],
      }
    }
  },
  mounted() {
    if (this.menus.length == 0) {
      return
    }
    let routeIndex = this.menus[0].route;
    if (this.menus[0].childrenList && this.menus[0].childrenList.length > 0) {
      routeIndex = this.menus[0].childrenList[0].route
      this.goPath(routeIndex)
    }
  },
  methods: {
    ...mapMutations(['clearToken']),

    jiequ() {
      this.username = this.userName.substring(0, this.userName.indexOf('@'));
    },
    change() {
      this.changeView = true;
      this.ruleForm.userName = this.userName;
      this.ruleForm.prepassword = "";
      this.ruleForm.password = "";
      this.ruleForm.dstPassword = "";
    },
    savePassword() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let param = {
            name: this.ruleForm.userName,
            password: window.getMD5(this.ruleForm.prepassword),
            dstPassword: window.getMD5(this.ruleForm.dstPassword),
          };
          let _this = this;
          this.$axios.post(this.baseUrl3 + 'user/modify/password', param)
            .then(({data: {msg, data, code}}) => {
              if (code == 20000) {
                localStorage.removeItem('userName')
                localStorage.removeItem('token')
                this.$router.push({
                  path: 'login',
                  name: 'login'
                })
              } else {
                _this.$message({showClose: true, message: msg, type: 'error'})
                console.log(msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          return false;
        }
      });
    },
    goPath(index) {
      this.$router.push({
        path: index
      });
    },
    select(index) {
      if (index == '/login') {
        this.clearToken()
      }
    },
    renderId(menu) {
      let str = menu.route.split('/').join('_')
      return 'id' + str
    },
    createDriver() {
      this.driver = new this.Driver({
        allowClose: false,
        nextBtnText: '下一步',
        prevBtnText: '上一步',
        doneBtnText: '结束',
        closeBtnText: '关闭'
      });
      // Define the steps for introduction
      this.driver.defineSteps([
        {
          element: '#id_container_devicelist',
          popover: {
            title: '设备管理',
            description: '首先创建一台设备',
          }
        },
        {
          element: '#id_container_deploy',
          popover: {
            title: '创建实例或编排',
            description: '您可以在下拉菜单中选择创建实例或者编排',
          }
        }, {
          element: '#id_container_monitor',
          popover: {
            title: '查看部署的实例',
            description: '您可以快速查看设备上部署的实例，也可以查看全部实例',
          }
        }
      ]);
      // Start the introduction
      this.driver.start();
    },
    showTips() {
      this.createDriver()
    }
  },
  created() {
    this.userName = localStorage.getItem("userName");
    this.jiequ();
  }
};
</script>


<style scoped>
.scrollable-menu {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto; /* 水平滚动条 */
  overflow-y: hidden; /* 防止垂直滚动条 */
  width: 100%; /* 让菜单填满父容器的宽度 */
  justify-content: space-between; /* 均匀分布菜单项 */
}

.headerDiv {
  height: 60px; /* 限制容器的高度 */
  width: 100%; /* 确保 headerDiv 填满宽度 */
  overflow-x: auto; /* 水平滚动条 */
  overflow-y: hidden; /* 防止垂直滚动条 */
  white-space: nowrap;
  display: flex;
}

.headerDiv >>> .el-menu-item, .headerDiv >>> .el-submenu__title {
  height: 60px; /* 保证菜单项的高度不超过容器 */
  line-height: 60px;
  border-bottom: 2px solid transparent;
  padding: 0 18px;
  white-space: nowrap;
  flex-shrink: 0;
  display: inline-block;
}




.el-submenu.is-active .el-submenu__title {
  border-bottom: 2px solid transparent;
}
.headerDiv >>> .el-submenu__icon-arrow {
  right: 4px;
  top: 54%;
}


</style>
